import React from "react";
import Navbar from "../organisms/nav-bar";
import Footer from "../molecules/footer";
import CarouselImg from "../atoms/CarouselImg";
import NewIn1 from "../atoms/new-in1";
import NewIn2 from "../atoms/new-in2";
import "./style/new-in-images.css";

function TemplateNewIn() {
	return (
		<div>
			<Navbar />
			<div style={{ marginTop: "10px" }}>
				<CarouselImg />
			</div>
			<div className="parent">
					<a
						href="https://www.dotbjewels.com/en/vomo/cufflinks-vomo-in-9k-black-gold-with-blue-agate"
						className="image-link"
						target="_blank"
						rel="noreferrer"
						style={{display:"flex", justifyContent:"center"}}
					>
						<NewIn1 />
					</a>
					<a
						href="https://www.dotbjewels.com/en/vomo/cufflinks-vomo-in-9k-rose-gold-with-lapis-lazuli-rubies-and-onyx"
						className="image-link"
						target="_blank"
						rel="noreferrer"
						style={{display:"flex", justifyContent:"center"}}
					>
						<NewIn2 />
					</a>
			</div>
			<Footer />
		</div>
	);
}

export default TemplateNewIn;
